/** Most products an event or template may preset, matching the size of the event product catalog. */
export const CAL_EVENT_MAX_PRODUCTS = 2000;
//# sourceMappingURL=cal-event-max-products.js.map